/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

export const LOADER_DELAY = 500;

export const SHOW_LOADER = '@@b2b_portal_ui/loader/SHOW_LOADER';
export const HIDE_LOADER = '@@b2b_portal_ui/loader/HIDE_LOADER';
export const SET_TEXT_LOADER = '@@b2b_portal_ui/loader/SET_TEXT_LOADER';
